import { tw } from '@careinfo/tailwind';
import { ColumnDef } from '@tanstack/react-table';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import APIS from '../../constant/EndPoint';
import DataTable from '../Reusable/DataTable';
import NACell from '../Reusable/DataTable/NACell';
import TrackingCell from '../Reusable/DataTable/TrackingCell';
import { getKey } from '../../helpers/sessionKey';

const EditPickupRequest = (props: any) => {
  const { data } = props;
  const [searchParams, setSearchParms] = useSearchParams({
    limit: '10',
    page: '0',
    searchQuery: '',
  });

  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get('selectAllItems');
    if (isSelected === '1') {
      searchParams.set('selectAllItems', '0');
      searchParams.delete('selectedItems');
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(',')
        .toString();
      searchParams.set('selectAllItems', '1');
      searchParams.set('selectedItems', selectedItems);
      setSearchParms(searchParams);
    }
  };

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get('selectedItems')?.split(',');
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get('selectedItems')?.split(',');
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set('selectedItems', value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(',')
        .toString();
      if (newSelectedItems.length) {
        searchParams.set('selectedItems', newSelectedItems);
      } else {
        searchParams.delete('selectedItems');
      }
      searchParams.set('selectAllItems', '0');
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(',')
        .toString();
      searchParams.set('selectedItems', newSelectedItems);
      setSearchParms(searchParams);
    }
  };

  const checkedAllItems = searchParams.get('selectAllItems') === '1';

  const defaultCargoColumns: ColumnDef<any, any>[] = [
    {
      header: 'WayBill',
      accessorKey: 'order.tracking_number',
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`cursor-pointer focus:outline-none`}>
            <p className={tw`whitespace-nowrap`}>{getValue() ?? 'N/A'}</p>
            <p className={tw`text-xs text-red-500`}>
              {row?.original?.invoice_print_count ? 'Printed' : null}
            </p>
          </div>
        );
      },
    },

    {
      header: 'Date',
      accessorKey: 'order.created',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <p className={tw`max-w-[80px]`}>
                {moment(getValue()).format('YY-MM-DD HH:mm:ss')}
              </p>
            ) : (
              'N/A'
            )}
          </>
        );
      },
    },
    {
      header: 'Forwarding No.',
      accessorKey: 'order.forwarding_no',
      cell: NACell,
    },
    {
      header: 'Sender',
      accessorKey: 'order.sender.full_name',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.sender?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: 'Receiver',
      accessorKey: 'order.receiver.full_name',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.receiver?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: 'Country',
      accessorKey: 'order.receiver.country',
      cell: NACell,
    },
    {
      header: 'Piece',
      accessorKey: 'order.total_piece',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: 'Weight',
      accessorKey: 'order.charge_wt',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    // {
    //   header: "Remarks",
    //   accessorKey: "remark",
    //   cell: ({ row, getValue }: any) => (
    //     <button
    //       onClick={() => {
    //         setSelectedOrder(row?.original?.id);
    //         setOpenReviewModal(true);
    //       }}
    //     >
    //       {getValue()} Remarks
    //     </button>
    //   ),
    // },
    {
      header: 'Created By',
      accessorKey: 'order.created_by',
      cell: NACell,
    },
    {
      header: 'Status',
      accessorKey: 'order.delivery_status.name',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{
                background: row?.original?.order?.delivery_status?.color,
              }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
    {
      header: 'Hub',
      accessorKey: 'order.hub.name',
      cell: NACell,
    },
    {
      header: 'P. Type',
      accessorKey: 'order.reference_type.name',
      cell: NACell,
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <AccessControl
    //       children={
    //         <div className={tw` w-full items-center`}>
    //           <div>
    //             <TableActionButton editPath={`edit/${getValue()}`} />
    //           </div>
    //         </div>
    //       }
    //       allowedPermissions={["can_editupdate_consignment"]}
    //     />
    //   ),
    // },
  ];

  const defaultColumns: ColumnDef<any, any>[] = [
    {
      id: 'select',
      header: ({ table }) => {
        return (
          <input
            type='checkbox'
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }) => (
        <input
          type='checkbox'
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: 'WayBill',
      accessorKey: 'order.tracking_number',
      cell: TrackingCell,
    },
    {
      header: 'Origin',
      accessorKey: 'order.pickup_branch.name',
      cell: NACell,
    },
    {
      header: 'Destination',
      accessorKey: 'order.destination.name',
      cell: NACell,
    },
    {
      header: 'Receiver',
      accessorKey: 'order.receiver.full_name',
      cell: NACell,
    },

    {
      header: 'Weight',
      accessorKey: 'order.weight',
      cell: ({ row, getValue }: any) => (
        <p>
          {row?.original?.order?.package_type?.unit === 'Gm'
            ? Number(getValue() * 1000) || 0
            : getValue() || 0}
          <span className='text-gray-500 text-xs'>
            {row?.original?.order?.package_type?.unit}
          </span>
        </p>
      ),
    },
    {
      header: 'Remarks',
      accessorKey: 'order.remark',
      cell: ({ getValue }: any) => <p>{getValue()} Remarks</p>,
    },
  ];
  const handleOrderDetailNavigate = (row: any) => {};
  const clientType = getKey('client-type');
  return (
    <>
      <DataTable
        url={APIS.PICKUPREQUEST_ITEMS}
        queryKey={'pickup-request-items'}
        columns={clientType === 'cargo' ? defaultCargoColumns : defaultColumns}
        params={{ pickup_request: data?.id }}
        tableName={'pickup-request-items'}
        handleEditNavigate={handleOrderDetailNavigate}
        actionMenu={<></>}
      />
    </>
  );
};

export default EditPickupRequest;
